/* eslint-disable */

import React, {useEffect, useState, useMemo} from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import { MuiTelInput } from 'mui-tel-input'
import PageContainer  from '../../components/PageContainer/PageContainer';
import {
          selectPageSize,
          setPageSize } from './slice';
import { selectNewRestaurantCount,
  selectAdminRestaurants,
  selectRowCount,
  selectShouldOpen,
  selectMessage,
  selectSeverity,
  setCurrentPage,
  selectCurrentPage,
  selectIsLoading,
  fetchRestaurantsAdminDashboard
  } from '../Restaurant/slice';
import { useAppSelector, useAppDispatch } from '../../redux/hooks';
import { Container, Summary, ContentHeader, Title, ActionToolbar, SearchContainer, ContentBody, RestaurantGrid, RestaurantCard, CardContent, CardInfo, CardMeta, CardActions, PaginationContainer, PaginationInfo, PaginationControls, PageSizeControl } from './Dashboard.styled';
import { useNavigate } from 'react-router-dom';
import DashboardSummary, { Item } from '../../components/DashboardSummary/DashboardSummary';
import { Restaurant } from '../Restaurant/types';
import { deleteRestaurant,
          selectNeedsWebsiteCount,
          selectNeedsTagsAndDescriptions,
          selectCountByStatus,
          selectTopCities,
          setOpen,
          generateTagsAndDescriptions,
          publishAllRestaurants } from '../Restaurant/slice';
import { manualRestaurantAdd } from '../Admin/slice';

import { withAuthenticationRequired } from '@auth0/auth0-react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


const Dashboard: React.FC = () => {
  const openServer = useAppSelector(selectShouldOpen);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const restaurantFromServer = useAppSelector(selectAdminRestaurants);
  const pageSize = useAppSelector(selectPageSize)
  const [restaurants, setRestaurants] = useState(restaurantFromServer);
  const [searchQuery, setSearchQuery] = useState('');
  const [phoneModalOpen, setPhoneModalOpen] = useState(false);
  const [phone, setPhone] = useState('');
  const rowCount = useAppSelector(selectRowCount);
  const newRestaurantCount = useAppSelector(selectNewRestaurantCount);
  const needsWebsiteCount = useAppSelector(selectNeedsWebsiteCount);
  const needsTagsAndDescriptions = useAppSelector(selectNeedsTagsAndDescriptions);
  const countByStatus = useAppSelector(selectCountByStatus);
  const topCities = useAppSelector(selectTopCities);
  const currentPage = useAppSelector(selectCurrentPage);

  useEffect(()=>{
    setRestaurants(restaurantFromServer)
  },[
    restaurantFromServer
  ])

  useEffect(() => {
    dispatch(fetchRestaurantsAdminDashboard(currentPage));
  }, [dispatch, currentPage, pageSize])

  const filteredRestaurants = useMemo(() => {
    if (!searchQuery.trim()) {
      return restaurants;
    }
    const lowerQuery = searchQuery.toLowerCase();
    return restaurants?.filter(restaurant =>
      (restaurant.name?.toLowerCase().includes(lowerQuery) ?? false) ||
      (restaurant.location?.toLowerCase().includes(lowerQuery) ?? false) ||
      (restaurant.status?.toLowerCase().includes(lowerQuery) ?? false)
    ) ?? [];
  }, [restaurants, searchQuery]);

  const newRestaurants: Item[] = [
    {
      name: "New Restaurants",
      value: ''+newRestaurantCount
    },
    {
      name: "Needs Website",
      value: ''+needsWebsiteCount
    },
    {
      name: "Needs Tags & Descriptions",
      value: ''+needsTagsAndDescriptions
    }
  ]

  const location: Item[] = topCities?.map((city) => {
    const item: Item = {
                        name: city.name,
                        value: ''+city.count
                      }
      return item;
    })??[]

  const statuses: Item[] = countByStatus?.map((city) => {
    const item: Item = {
                        name: city?.name,
                        value: ''+city?.count
                      }
      return item;
    })??[]

  const setOpenServer = (open: boolean) => {
    dispatch(setOpen(open));
  }

  const message = useAppSelector(selectMessage);
  const severity = useAppSelector(selectSeverity);
  const isLoading = useAppSelector(selectIsLoading);

  const totalPages = Math.ceil(rowCount / pageSize);
  const startIndex = currentPage * pageSize + 1;
  const endIndex = Math.min((currentPage + 1) * pageSize, rowCount);
  const hasNextPage = currentPage < totalPages - 1;
  const hasPreviousPage = currentPage > 0;

  const handlePhoneModalOpen = () => {
    setPhoneModalOpen(true);
  };

  const handlePhoneModalClose = () => {
    setPhoneModalOpen(false);
    setPhone('');
  };

  const handlePhoneChange = (newValue: string) => {
    setPhone(newValue);
  };

  const handleCreateRestaurant = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const restaurant: Restaurant = {
      status: 'NEW',
      address1: '',
      alias: '',
      city: '',
      country: '',
      name: '',
      placeId: '',
      restaurantId: '',
      state: '',
      phone
    };

    try {
      const result = await dispatch(manualRestaurantAdd(restaurant)).unwrap();
      handlePhoneModalClose();
      if (result?.alias) {
        navigate(`/restaurant/${result.alias}`);
      }
    } catch (error) {
      console.error('Failed to create restaurant:', error);
    }
  };

  return (
    <PageContainer title='Dashboard' open={openServer} setOpen={setOpenServer} message={message} severity={severity}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>
        <Summary>
          <DashboardSummary items={newRestaurants}/>
          <DashboardSummary items={location}/>
          <DashboardSummary items={statuses}/>
        </Summary>

        <ContentHeader>
          <Title>Restaurants</Title>
          <ActionToolbar>
            <Button
              variant="outlined"
              size="small"
              disabled={isLoading}
              onClick={() => { void dispatch(generateTagsAndDescriptions()); }}
            >
              Generate Tags & Descriptions
            </Button>
            <Button
              variant="outlined"
              size="small"
              disabled={isLoading}
              onClick={() => { void dispatch(publishAllRestaurants()); }}
            >
              Publish All Restaurants
            </Button>
            <Button
              variant="contained"
              size="small"
              onClick={handlePhoneModalOpen}
            >
              Add Restaurant
            </Button>
          </ActionToolbar>
        </ContentHeader>

        <SearchContainer>
          <TextField
            placeholder="Search by name, location, or status..."
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </SearchContainer>

        <ContentBody>
          <RestaurantGrid>
            {filteredRestaurants?.map((restaurant) => (
              <RestaurantCard
                key={restaurant.restaurantId}
                onClick={() => navigate(`/restaurant/${restaurant.alias}`)}
              >
                <CardContent>
                  {restaurant.imageUrl && (
                    <img
                      src={restaurant.imageUrl}
                      alt={restaurant.name}
                      style={{
                        width: '100%',
                        height: '120px',
                        objectFit: 'cover',
                        borderRadius: '4px',
                        marginBottom: '8px'
                      }}
                    />
                  )}
                  <CardInfo>
                    <div><strong>{restaurant.name}</strong></div>
                    <div>{restaurant.location}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      Created: {new Date(restaurant.created).toLocaleDateString()}
                    </div>
                  </CardInfo>
                </CardContent>

                <CardMeta>
                  <div><span style={{ fontWeight: 600 }}>Menus:</span> {restaurant.menuCount}</div>
                  <div>
                    <span style={{ fontWeight: 600 }}>Status:</span>
                    <span style={{
                      marginLeft: '4px',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      backgroundColor: restaurant.status === 'LIVE' ? '#d4edda' : '#e2e3e5',
                      color: restaurant.status === 'LIVE' ? '#155724' : '#383d41'
                    }}>
                      {restaurant.status}
                    </span>
                  </div>
                  {restaurant.verified && (
                    <div style={{ color: '#ff8c42', fontWeight: 600 }}>
                      ✓ Verified
                    </div>
                  )}
                </CardMeta>

                <CardActions>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/restaurant/${restaurant.alias}`);
                    }}
                  >
                    View
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(deleteRestaurant(restaurant.restaurantId));
                    }}
                  >
                    Delete
                  </Button>
                </CardActions>
              </RestaurantCard>
            ))}
          </RestaurantGrid>
        </ContentBody>

        <PaginationContainer>
          <PaginationInfo>
            Showing {rowCount > 0 ? startIndex : 0} to {endIndex} of {rowCount} restaurants
          </PaginationInfo>

          <PaginationControls>
            <Button
              variant="outlined"
              size="small"
              disabled={!hasPreviousPage}
              onClick={() => dispatch(setCurrentPage(currentPage - 1))}
            >
              Previous
            </Button>
            <PaginationInfo>
              Page {currentPage + 1} of {totalPages}
            </PaginationInfo>
            <Button
              variant="outlined"
              size="small"
              disabled={!hasNextPage}
              onClick={() => dispatch(setCurrentPage(currentPage + 1))}
            >
              Next
            </Button>
          </PaginationControls>

          <PageSizeControl>
            <FormControl size="small" fullWidth>
              <InputLabel>Page Size</InputLabel>
              <Select
                value={pageSize}
                label="Page Size"
                onChange={(e) => {
                  dispatch(setPageSize(Number(e.target.value)));
                  dispatch(setCurrentPage(0));
                }}
              >
                <MenuItem value={25}>25 per page</MenuItem>
                <MenuItem value={50}>50 per page</MenuItem>
                <MenuItem value={100}>100 per page</MenuItem>
              </Select>
            </FormControl>
          </PageSizeControl>
        </PaginationContainer>
      </Container>

      <Dialog open={phoneModalOpen} onClose={handlePhoneModalClose}>
        <DialogTitle>Add Restaurant</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To create a restaurant, add restaurant phone number below
          </DialogContentText>
          <form onSubmit={handleCreateRestaurant} id="create-restaurant-form">
            <MuiTelInput
              value={phone}
              onChange={handlePhoneChange}
              fullWidth
              autoFocus
              sx={{ marginTop: '16px' }}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlePhoneModalClose}>Cancel</Button>
          <Button type="submit" form="create-restaurant-form" variant="contained">
            Create Restaurant
          </Button>
        </DialogActions>
      </Dialog>
    </PageContainer>
  )
}

export default withAuthenticationRequired(Dashboard);
